export const ProviderSpecialtyBoardCertification = [
    { value: 'Board Lifetime Certified', label: 'Board Lifetime Certified' },
    { value: 'Eligible for Boards', label: 'Eligible for Boards' },
    { value: 'Not Board Certified', label: 'Not Board Certified' }
];

Object.freeze(ProviderSpecialtyBoardCertification);